import React, { useState, useEffect } from 'react';
import API from '../services/api';
import './DelegateDashboard.css';

const DelegateDashboard = () => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const fetchTasks = async () => {
      try {
        setLoading(true);
        const response = await API.get('/api/delegate-tasks');
        
        if (response.data.success) {
          setTasks(response.data.tasks || []);
        } else {
          throw new Error(response.data.message || 'Failed to load tasks');
        }
        
        setLoading(false);
      } catch (err) {
        console.error('Error loading delegate tasks:', err);
        setError('Failed to load delegate tasks. Please try again later.');
        setLoading(false);
      }
    };
    
    fetchTasks();
  }, []);
  
  if (loading) {
    return <div className="loading">Loading your tasks...</div>;
  }
  
  if (error) {
    return <div className="error-message">{error}</div>;
  }
  
  if (!tasks || tasks.length === 0) {
    return (
      <div className="delegate-dashboard empty-state">
        <h2>My Assigned Tasks</h2>
        <div className="no-tasks">
          <i className="fas fa-clipboard-check"></i>
          <p>You don't have any investigation tasks assigned to you.</p>
        </div>
      </div>
    );
  }
  
  console.log('Tasks available:', tasks);
  console.log('First task details:', tasks[0]);
  
  return (
    <div className="delegate-dashboard">
      <h2>My Assigned Tasks</h2>
      
      <div className="task-counts">
        <div className="count-badge pending">
          <span className="count">
            {tasks.filter(task => task.INVESTIGATION_STATUS !== 'COMPLETED').length}
          </span>
          <span className="label">Pending</span>
        </div>
        <div className="count-badge completed">
          <span className="count">
            {tasks.filter(task => task.INVESTIGATION_STATUS === 'COMPLETED').length}
          </span>
          <span className="label">Completed</span>
        </div>
      </div>
      
      <div className="tasks-container">
        <h3>Assigned Investigations</h3>
        <table className="tasks-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Title</th>
              <th>Date</th>
              <th>Department</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {tasks.map(task => (
              <tr key={task.ID} className={getRowClassName(task.INVESTIGATION_STATUS)}>
                <td>#{task.ID}</td>
                <td>{task.TITLE}</td>
                <td>{new Date(task.DATE).toLocaleDateString()}</td>
                <td>{task.PRIMARY_DEPARTMENT}</td>
                <td>
                  <span className={`status-badge ${task.INVESTIGATION_STATUS?.toLowerCase() || 'unknown'}`}>
                    {formatStatus(task.INVESTIGATION_STATUS)}
                  </span>
                </td>
                <td style={{
                  padding: '8px', 
                  textAlign: 'center',
                  minWidth: '100px',  // Ensure minimum width 
                  maxWidth: '120px',  // Cap the maximum width
                  overflow: 'visible' // Make sure content isn't cut off
                }}>
                  <button
                    onClick={() => {
                      const url = task.INVESTIGATION_STATUS === 'COMPLETED' 
                        ? `/incidents/${task.ID}`
                        : `/incidents/${task.ID}/delegate-submit`;
                      window.location.href = url;
                    }}
                    style={{
                      backgroundColor: task.INVESTIGATION_STATUS === 'COMPLETED' ? '#f0f0f0' : '#2196f3',
                      color: task.INVESTIGATION_STATUS === 'COMPLETED' ? '#455a64' : 'white',
                      padding: '6px 12px',
                      width: '90%',      // Use most of the cell width
                      margin: '0 auto',  // Center the button
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      whiteSpace: 'nowrap', // Keep text on one line
                      display: 'block'     // Make it a block element to respect width
                    }}
                  >
                    {task.INVESTIGATION_STATUS === 'COMPLETED' ? 'View' : 
                      (task.INVESTIGATION_STATUS === 'NEEDS_REVISION' ? 'Revise' : 'Complete')}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

function getRowClassName(status) {
  switch(status) {
    case 'NEEDS_REVISION': return 'needs-attention';
    case 'COMPLETED': return 'completed';
    default: return '';
  }
}

function formatStatus(status) {
  switch(status) {
    case 'OPEN': return 'Open';
    case 'SUBMITTED': return 'Submitted';
    case 'NEEDS_REVISION': return 'Needs Revision';
    case 'COMPLETED': return 'Completed';
    default: return status || 'Unknown';
  }
}

export default DelegateDashboard;